module.exports = __webpack_public_path__ + "img/grafico-2.bca73893.svg";